// This is to fix amplify, but putting `global: globalThis` in vite.config.js causes
// `vite build` errors when vitejs then tries to include `globalThis.js`.
(globalThis as any).global = globalThis;

export {};
